export class AwsEksNamespaceSnapshotProperties {
    'volumes';
    'secretsCount';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "volumes",
            "baseName": "volumes",
            "type": "Array<InventorySnapshotVolume>",
            "format": ""
        },
        {
            "name": "secretsCount",
            "baseName": "secretsCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsEksNamespaceSnapshotProperties.attributeTypeMap;
    }
    constructor() {
    }
}
